import { defineModel } from "../define-model";

export type AdAccount = {
	id: string;
	workspaceId: string;
	projectId: string;
	platform: string;
	zernioAccountId: string;
	platformAdAccountId: string;
	name: string;
	currency: string;
	status: string;
	metadata: Record<string, unknown>;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		adAccount: AdAccount;
	}
}

export const model = defineModel({ name: "adAccount", load: "eager", indexes: ["projectId"] });
